export default __webpack_public_path__ + "static/media/money.e8e73c57.svg";